module.exports = __webpack_public_path__ + "img/IT0004215764223.668b6fb2.png";